// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"5b0bb44a","118":"d86c55a0","329":"64b1a67e","534":"96c721d9","676":"2cb498bf","787":"28cb0dcd","829":"4e3820cf","882":"870b0db7"}[chunkId] + ".chunk.js";
};